import React from 'react';

interface ConfirmationModalProps {
    isOpen: boolean;
    onConfirm: () => void;
    onCancel: () => void;
    title: string;
    children: React.ReactNode;
    confirmText?: string;
    confirmButtonClass?: string;
    maxWidthClass?: string;
    fullWidth?: boolean;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({ isOpen, onConfirm, onCancel, title, children, confirmText = 'Confirmar', confirmButtonClass = 'bg-red-600 hover:bg-red-700', maxWidthClass = 'max-w-2xl', fullWidth = false }) => {
    if (!isOpen) {
        return null;
    }

    return (
        <div 
            className={`fixed inset-0 bg-black bg-opacity-50 dark:bg-opacity-70 z-50 flex justify-center ${fullWidth ? 'items-start p-0' : 'items-center p-4'}`}
            aria-modal="true"
            role="dialog"
        >
            <div className={`bg-white dark:bg-slate-800 ${fullWidth ? 'rounded-none max-h-[100vh]' : 'rounded-lg max-h-[90vh]'} shadow-2xl w-full ${maxWidthClass} animate-fade-in flex flex-col`}
            >
                <div className="px-6 pt-6">
                    <h2 className="text-2xl font-bold text-gray-900 dark:text-white">{title}</h2>
                </div>
                <div className="px-6 pb-0 flex-1 overflow-y-auto text-center">
                    <div className="text-gray-600 dark:text-slate-300">{children}</div>
                </div>
                <div className="flex justify-center gap-4 px-6 py-6 border-t border-gray-200 dark:border-slate-700 bg-white dark:bg-slate-800">
                    <button
                        onClick={onCancel}
                        className="bg-gray-200 hover:bg-gray-300 text-gray-800 dark:bg-slate-600 dark:hover:bg-slate-500 dark:text-white font-bold py-2 px-6 rounded-lg transition-colors"
                    >
                        Cancelar
                    </button>
                    <button
                        onClick={onConfirm}
                        className={`${confirmButtonClass} text-white font-bold py-2 px-6 rounded-lg transition-colors`}
                    >
                        {confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmationModal;
